import { render, staticRenderFns } from "./modal-confirma-sobrescrita-paciente-his-backoffice.vue?vue&type=template&id=8f6e87c2"
import script from "./modal-confirma-sobrescrita-paciente-his-backoffice.vue?vue&type=script&lang=ts"
export * from "./modal-confirma-sobrescrita-paciente-his-backoffice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports